import { render, staticRenderFns } from "./RequestedDocumentsTypesOfRequestedDocumentsPage.vue?vue&type=template&id=5aac92ae&"
import script from "./RequestedDocumentsTypesOfRequestedDocumentsPage.vue?vue&type=script&lang=js&"
export * from "./RequestedDocumentsTypesOfRequestedDocumentsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports